import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Radio, Space } from 'antd';
import type { ActionPlanStatusKey, ActionPlanStatusLabel } from '@/types/DataExtraction';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

interface RadioOption {
	key: ActionPlanStatusKey;
	label: ActionPlanStatusLabel;
}

export function ActionPlanFormItem(): JSX.Element {
	const options: RadioOption[] = [
		{ key: 'included', label: 'Included' },
		{ key: 'excluded', label: 'Not included' },
		{ key: 'both', label: 'Both' }
	];

	return (
		<FormItemWrapper label={I18n.get('Action Plans')} name="action_plan_status" labelCol={{ span: 24 }}>
			<Radio.Group>
				<Space direction="horizontal">
					{options.map(({ key, label }) => (
						<S.RadioWrapper key={key} value={key}>
							{I18n.get(label)}
						</S.RadioWrapper>
					))}
				</Space>
			</Radio.Group>
		</FormItemWrapper>
	);
}
